import { CapabilityGate } from '../components/CapabilityGate';
import { PainelV3 } from '../features/agent-dashboard/painel-v3/PainelV3';

/**
 * PainelPessoalPage — rota `/painel`. Home do operador, conceito V3 "Corrente"
 * (Item 371): Pulso · Corrente · Teia. Gateada em `agent-dashboard-read`.
 */
export function PainelPessoalPage(): JSX.Element {
  return (
    <CapabilityGate
      capability="agent-dashboard-read"
      fallback={
        <div className="flex flex-col h-full">
          <div className="app-pagehead">
            <div className="app-pagehead__top">
              <h1 className="app-pagehead__title">Painel Pessoal</h1>
            </div>
          </div>
          <div className="empty-state">
            <div className="empty-state__title">Sem acesso ao painel pessoal neste tenant.</div>
          </div>
        </div>
      }
    >
      <PainelV3 />
    </CapabilityGate>
  );
}
